
    <ng-container [ngSwitch]="layout">
      <ng-container *ngSwitchCase="'table'">
        <div class="div-table-th" *ngIf="options['header']">
          <div class="row">
            <div class="col-2"><span class="pl-1">#Id</span></div>
            <div class="col-2">First Name</div>
            <div class="col-2">Last Name</div>
            <div class="col-2">Display Name</div>
            <div class="col-2">Email</div>
            <div class="col">Actions</div>
          </div>
        </div>
        <div
          [ngClass]="{
            'div-table-tr': options['index'] % 2 == 1,
            'div-table-tr-alt': options['index'] % 2 == 0
          }"
        >
          <div class="row">
            <div class="col-2 text-truncate">
              <span class="pl-1"
                ><a
                  [routerLink]="'/portal/users/show/' + entity.identifier"
                  title="{{ entity.identifier }}"
                  ><i class="pr-1 text-dark fa fa-link"> </i></a
                ><a
                  title="{{ entity.identifier }}"
                  href="/portal/users/show/{{ entity.identifier }}"
                  (click)="showUserWidgetModal(userWidget, $event)"
                  >{{ entity.identifier }}</a
                ></span
              >
            </div>
            <div class="col-2 text-truncate" title="{{ entity.first_name }}">
              {{ entity.first_name }}
            </div>
            <div class="col-2 text-truncate " title="{{ entity.last_name }}">
              {{ entity.last_name }}
            </div>
            <div class="col-2 text-truncate" title="{{ entity.display_name }}">
              {{ entity.display_name }}
            </div>
            <div class="col-2 text-truncate" title="{{ entity.email }}">
              {{ entity.email }}
            </div>
            <div class="col">
              <span class="badge badge-info">Send Password Reset Email</span>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngSwitchCase="'mini'">
        <div class="row">
          <div class="col-auto"><strong>User:</strong></div>
          <div class="col text-truncate">
            <a
              [routerLink]="'/portal/users/show/' + entity.identifier"
              class="text-truncate"
              title="{{ entity.identifier }}"
              >{{ entity.identifier }}</a
            >
          </div>
        </div>
        <div class="row" *ngIf="entity.first_name || entity.last_name">
          <div class="col-auto"><strong>Name:</strong></div>
          <div class="col">{{ entity.first_name }} {{ entity.last_name }}</div>
        </div>
        <div class="row">
          <div class="col-auto"><strong>Email:</strong></div>
          <div class="col">{{ entity.email }}</div>
        </div>
      </ng-container>

      <ng-container *ngSwitchDefault>
        <div class="card shadow" *ngIf="entity">
          <div class="card-header">
            <div class="row">
              <div class="col">
                <span class="font-weight-bold"
                  >User Widget |
                  <a [routerLink]="'/portal/users/show/' + entity.identifier">{{
                    entity.email
                  }}</a></span
                >
                <span *ngIf="options" class="float-right"
                  ><i
                    (click)="toggleExpand()"
                    class="fa fa-sm"
                    [ngClass]="{
                      'fa-chevron-down': !options.expand,
                      'fa-chevron-up': options.expand
                    }"
                  >
                  </i
                ></span>
              </div>
            </div>
          </div>
          <div class="card-body p-1 m-0" *ngIf="entity && expandWidget()">
            <div class="row">
              <div class="col-4 font-weight-bold">Name:</div>
              <div class="col">
                {{ entity.last_name || "-" }}, {{ entity.first_name || "-" }}
              </div>
            </div>
            <div class="row">
              <div class="col-4 font-weight-bold">Is Staff?</div>
              <div class="col">{{ (entity.isStaff | json) || "false" }}</div>
            </div>
            <div class="row">
              <div class="col-4 font-weight-bold">Email:</div>
              <div class="col">{{ entity.email || "-" }}</div>
            </div>
            <div class="row">
              <div class="col-4 font-weight-bold">Mobile:</div>
              <div class="col">{{ entity.mobile || "-" }}</div>
            </div>
            <div class="row">
              <div class="col-4 font-weight-bold">Group Id:</div>
              <div class="col">{{ entity.group_id || "-" }}</div>
            </div>
            <div class="row flex">
              <div class="col-4 font-weight-bold">Admin Permissions:</div>

              <div class="col">
                <div
                  class="row"
                  *ngFor="
                    let perm of entity.adminPermissions | keyvalue;
                    let i = index
                  "
                >
                  <div class="col-8 text-start">
                    {{ i + 1 }}) {{ perm.key }}
                  </div>
                  <div
                    class="col-2 text-center btn-pill mb-1 pl-1 pr-1 rounded text-white"
                    [ngClass]="{
                      'bg-success': perm.value === 'granted',
                      'bg-danger': perm.value !== 'granted'
                    }"
                  >
                    {{ perm.value }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <tabset #userTabs class="col">
                <tab heading="Settings">
                  <div class="row">
                    <div class="col">
                      <user-settings-widget
                        [entity]="entity"
                        [options]="options"
                      ></user-settings-widget>
                    </div>
                  </div>
                </tab>
                <tab heading="Devices">
                  <div class="row">
                    <div class="col">
                      <user-devices-widget
                        [entity]="entity"
                        [options]="options"
                      ></user-devices-widget>
                    </div>
                  </div>
                </tab>
                <tab heading="Locations">
                  <div class="row">
                    <div class="col">[PENDING]</div>
                  </div>
                </tab>
                <tab heading="Channels">
                  <div class="row">
                    <div class="col">[PENDING]</div>
                  </div>
                </tab>
                <tab heading="Alerts">
                  <div class="row">
                    <div class="col">[PENDING]</div>
                  </div>
                </tab>
                <tab heading="Events">
                  <div class="row">
                    <div class="col">[PENDING]</div>
                  </div>
                </tab>
                <tab heading="Notifications">
                  <div class="row">
                    <div class="col">[PENDING]</div>
                  </div>
                </tab>
                <tab heading="Subscriptions">
                  <div class="row">
                    <div class="col">[PENDING]</div>
                  </div>
                </tab>
                <tab heading="Logs">
                  <div class="row">
                    <div class="col">[PENDING]</div>
                  </div>
                </tab>
                <tab heading="Groups">
                  <div class="row">
                    <div class="col">[PENDING]</div>
                  </div>
                </tab>
              </tabset>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <ng-template #userWidget>
      <!-- Modal Header -->
      <div
        class="modal-header bg-light d-flex justify-content-between align-items-center"
      >
        <h4 class="modal-title m-0 h5">{{ currentModal?.title }}</h4>
        <button
          type="button"
          class="close pull-right"
          aria-label="Close"
          (click)="userListModalRef.hide()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="card shadow-sm mb-4" *ngIf="entity">
        <div
          class="card-header bg-primary text-white d-flex justify-content-between align-items-center"
        >
          <div>
            <span class="font-weight-bold">User Widget</span> |
            <a
              [routerLink]="'/portal/users/show/' + entity.identifier"
              class="text-white text-decoration-underline font-weight-bold"
            >
              {{ entity.email }}
            </a>
          </div>
        </div>

        <div class="card-body py-3 px-4" *ngIf="entity">
          <div class="row mb-2">
            <div class="col-4 font-weight-bold">Name:</div>
            <div class="col">
              {{ entity.last_name || "-" }}, {{ entity.first_name || "-" }}
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-4 font-weight-bold">Is Staff?</div>
            <div class="col">{{ entity.isStaff | json }}</div>
          </div>

          <div class="row mb-2">
            <div class="col-4 font-weight-bold">Email:</div>
            <div class="col">{{ entity.email || "-" }}</div>
          </div>

          <div class="row mb-2">
            <div class="col-4 font-weight-bold">Mobile:</div>
            <div class="col">{{ entity.mobile || "-" }}</div>
          </div>

          <div class="row mb-3">
            <div class="col-4 font-weight-bold">Group ID:</div>
            <div class="col">{{ entity.group_id || "-" }}</div>
          </div>

          <div class="row mb-3">
            <div class="col-4 font-weight-bold">Admin Permissions:</div>
            <div class="col">
              <div
                *ngIf="
                  entity.adminPermissions &&
                    (entity.adminPermissions | keyvalue).length > 0;
                  else noPermissions
                "
              >
                <div
                  class="row g-2"
                  *ngFor="
                    let perm of entity.adminPermissions | keyvalue;
                    let i = index
                  "
                >
                  <div class="col-md-8">{{ i + 1 }}) {{ perm.key }}</div>
                  <div
                    class="col-md-4 text-center rounded-pill py-1 text-white fw-medium"
                    [ngClass]="{
                      'bg-success': perm.value === 'granted',
                      'bg-danger': perm.value !== 'granted'
                    }"
                  >
                    {{ perm.value }}
                  </div>
                </div>
              </div>

              <ng-template #noPermissions>
                <div class="col">No permissions</div>
              </ng-template>
            </div>
          </div>

          <div class="mt-4">
            <tabset>
              <tab heading="Settings">
                <div class="pt-2">
                  <user-settings-widget
                    [entity]="entity"
                    [options]="options"
                  ></user-settings-widget>
                </div>
              </tab>
              <tab heading="Devices">
                <div class="pt-2">
                  <user-devices-widget
                    [entity]="entity"
                    [options]="options"
                  ></user-devices-widget>
                </div>
              </tab>
              <tab heading="Locations"><div class="pt-2">[PENDING]</div></tab>
              <tab heading="Channels"><div class="pt-2">[PENDING]</div></tab>
              <tab heading="Alerts"><div class="pt-2">[PENDING]</div></tab>
              <tab heading="Events"><div class="pt-2">[PENDING]</div></tab>
              <tab heading="Notifications"
                ><div class="pt-2">[PENDING]</div></tab
              >
              <tab heading="Subscriptions"
                ><div class="pt-2">[PENDING]</div></tab
              >
              <tab heading="Logs"><div class="pt-2">[PENDING]</div></tab>
              <tab heading="Groups"><div class="pt-2">[PENDING]</div></tab>
            </tabset>
          </div>
        </div>
      </div>
      <!-- Modal Footer -->
      <div class="modal-footer bg-light">
        <button
          *ngIf="currentModal?.cancelMsg"
          type="button"
          class="btn btn-outline-secondary"
          (click)="currentModal?.cancel()"
          data-dismiss="modal"
        >
          {{ currentModal?.cancelMsg }}
        </button>
        <button
          *ngIf="currentModal?.deleteMsg"
          type="button"
          class="btn btn-outline-danger"
          (click)="currentModal?.delete()"
          data-dismiss="modal"
        >
          {{ currentModal?.deleteMsg }}
        </button>
        <button
          *ngIf="currentModal?.revertMsg"
          type="button"
          class="btn btn-outline-warning"
          (click)="currentModal?.revert()"
          data-dismiss="modal"
        >
          {{ currentModal?.revertMsg }}
        </button>
        <button
          *ngIf="currentModal?.confirmMsg && entity?.pending"
          type="button"
          class="btn btn-primary"
          (click)="currentModal?.confirm()"
        >
          {{ currentModal?.confirmMsg }}
        </button>
      </div>
    </ng-template>
  